import Api from "./api";

class CategoryService extends Api {}

export default new CategoryService({
  ressource: "/admin/categories"
});
